

// Define action constants
module.exports = {
	UserID: "UserID",
	UserName: "UserName",
	Password: "Password",
	Hash: "Hash",
	FirstName: "FirstName",
	LastName: "LastName",
	Birthday: "DOB",
	IsAdmin: "Admin",
	Credits: "Credit",
	Credit: "Credit",
	Points: "Points",
	UserCreditsQRID: "QRCode_Pay",
	UserPointsQRID: "QRCode_Redeem",
	LastFour: "STRIPE_lastFour",
	PaymentType: "STRIPE_paymentType",
	StripeKey: "STRIPE_pubKey",
	PayPalClientID: "PayPalClientID",
	PayPal_Environment: "PayPal_Environment",
	CardType: "STRIPE_cardType",
	PaymentInfo: "PaymentInfo",
	PayPal_ClientID: "PayPal_ClientID",
	DirtyPassword: "DirtyPassword",
	CC_Gateway_Primary: "CC_Gateway_Primary",
	PayMode: "PayMode",
	PhoneNumber: "PhoneNumber",
	ShowPhoneNumber: "ShowPhoneNumber",
	RequirePhoneForPurchase: "RequirePhoneForPurchase",
	RequirePhoneForRewards: "RequirePhoneForRewards",
	RequirePostalCode: "RequirePostalCode",
	RequirePhoneForPaymentTypes: "RequirePhoneForPaymentTypes",
	HasPassword: "HasPassword",
	HasFacebook: "HasFacebook",
	DefaultDistance: "DefaultDistance",
	UsePhoneLoyalty: "UsePhoneLoyalty",
	TotalCreditUsedAtScanner: "TotalCreditUsedAtScanner",
	TotalPointsUsedAtScanner: "TotalPointsUsedAtScanner",
	TotalPointsAddedAtScanner: "TotalPointsAddedAtScanner",
	OwnerUserID: "OwnerUserID",
	CanJoinGroups: "CanJoinGroups",
	JoinedGroupNames: "JoinedGroupNames",
	SupportEmail: "SupportEmail",
	ClassNames: "ClassNames",
};
